// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sfProDisplayFont_d307b1', '__sfProDisplayFont_Fallback_d307b1'"},"className":"__className_d307b1"};